/**
 * @generated SignedSource<<a30ad2185f941abbc75f7f623d0be23f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ItemPrice_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useItemPriceData_item">;
  readonly " $fragmentType": "ItemPrice_item";
};
export type ItemPrice_item$key = {
  readonly " $data"?: ItemPrice_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"ItemPrice_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ItemPrice_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useItemPriceData_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "7026b5b0857ec02e6885a91c3278d688";

export default node;
